module.exports = __webpack_public_path__ + "static/media/Real-One-Specific-script.45e7e5b1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Real-One-Specific-script.woff2
// module id = 3647
// module chunks = 68